import {
  Button,
  FormControlLabel,
  Radio,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import Image from 'next/image';
import { useCallback } from 'react';

import type { StepProps } from '@/components/wizard/StepProps';

import type { IntegrationWizardState } from './integrationWizardFlow';

import { IntegrationVendorDetails, IntegrationVendor } from '../types';

export const IntegrationNameSelection = (
  props: StepProps<IntegrationWizardState>
) => {
  const next = () => {
    props.setNextStep(props.currentStep.next?.[0]);
  };

  const validateParams = useCallback(
    (name: string): boolean => {
      return name?.length >= 4 && !!props.wizardState.vendor;
    },
    [props.wizardState.vendor]
  );

  return (
    <Stack
      sx={{ height: '100%' }}
      alignItems='center'
      justifyContent='center'
      gap='24px'
    >
      <Typography variant='h3' sx={{ textAlign: 'center' }}>
        Integration name
      </Typography>
      <TextField
        autoFocus
        sx={{
          width: '655px',
          '& .MuiOutlinedInput-root': {
            padding: '8px',
          },
        }}
        placeholder='Example: prod fabric monitoring'
        onChange={(e) =>
          props.setWizardState((state) => ({
            ...state,
            name: e.target.value,
          }))
        }
        onKeyDown={(e) => {
          if (
            e.key === 'Enter' &&
            validateParams(props.wizardState.name || '')
          ) {
            next();
          }
        }}
        value={props.wizardState.name}
        slotProps={{
          input: {
            endAdornment: (
              <Button
                sx={{ width: '200px' }}
                variant='contained'
                disabled={!validateParams(props.wizardState.name || '')}
                onClick={next}
              >
                Next
                <i className='material-symbols-arrow-right-alt ml-[8px]' />
              </Button>
            ),
          },
        }}
      />
      <Stack direction='row'>
        {Object.entries(IntegrationVendorDetails)
          .filter(([key]) => key !== IntegrationVendor.UNKNOWN)
          .map(([key, value]) => (
            <div key={key}>
              <FormControlLabel
                control={
                  <Radio
                    disableRipple
                    sx={{ padding: '10px 10px 10px 30px' }}
                    size='small'
                    checked={key === props.wizardState.vendor}
                    onChange={() =>
                      props.setWizardState((state) => ({
                        ...state,
                        vendor: key as keyof typeof IntegrationVendorDetails,
                      }))
                    }
                  />
                }
                label={
                  <Stack direction='row' alignItems='center' gap='8px'>
                    <Image
                      alt={value.displayName}
                      src={value.logo}
                      width={24}
                      height={24}
                      style={{ width: '24px', height: '24px' }}
                    />
                    <Typography>{value.displayName}</Typography>
                  </Stack>
                }
              />
            </div>
          ))}
      </Stack>
    </Stack>
  );
};
